export default __webpack_public_path__ + "static/media/medx-social-14.645574da.png";